export default "__VITE_ASSET__DsTmUFTY__"